import { Component, OnInit, Input, Inject, LOCALE_ID } from '@angular/core';

/**
 * Component per mostrar el marcador d'una incidència
 */
@Component({
  selector: 'app-incidencia',
  templateUrl: './incidencia.component.html',
  styleUrls: ['./incidencia.component.css']
})
export class IncidenciaComponent implements OnInit {

  /**
   * Feature que conté les propietats per crear el marcador
   */
  @Input() feature;

  /**
   * Capa a la qual pertany el marcador
   */
  @Input() layer;

  /**
   * Conté les propietats del feature
   */
  properties;
  
  /**
   * Url de la icona a mostrar
   */
  iconUrl: string;
  
  /**
   * Carretera on s'ha produt la incidència
   */
  road: string;

  /**
   * Punt kilomètric inicial de la incidència 
   */
  start_kp: string; 

  /**
   * Punt kilomètric final de la incidència 
   */
  end_kp: string;

  /**
   * Ciutat on s'ha produit la incidència
   */
  city: string; 

  /**
   * Causa per la qual s'ha produit la incidència
   */
  cause: string; 

  /**
   * Comentaris sobre la incidència
   */
  comments: string;

  /**
   * Direcció de la carretera en la qual s'ha produit la incidència
   */
  direction: string;

  /**
   * Font d'informació 
   */
  source: string;

  /**
   * Nivell de perill de la incidència
   */
  levelOfService: string;
  
  /**
   * Identificador de la causa d'incidència meteorològica
   */
  meteoId: string;

  /**
   * Indica per cada identificador d'incidència meteorològica el seu nom en castellà
   */
  meteoIds: Map<string,string> = new Map([["20","Niebla"],["28","Cadenas"],["21","Hielo"],["42","Inundaciones"],["26","Lluvia"],["27","Nieve"],["33","Viento"]])

  
  /**
   * Constructor del component
   * @param {string} localeId indica l'idioma actual de la pàgina 
   */
  constructor(@Inject(LOCALE_ID) protected localeId: string) { }

  /**
   * Retorna el text per compartir el marcador
   * @returns {string} text per compartir el marcador
   */
  generateShareText(): string{
    var titol;
    if(this.localeId === 'es'){
      titol = this.cause + "%20en%20";
    } 
    else titol = this.cause + "%20a%20";
    return titol + this.road + "%20Km%20" + this.start_kp + "%20-%20" + this.end_kp + "%20" + this.city + ".%20#infotransit";
  }

  /**
   * Retorna la url que mostra el mapa centrat en el marcador
   * @returns {string} url que mostra el mapa centrat en el marcador
   */
  generateShareUrl(): string{
    var baseUrl = window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + '/infotransit';
    var params = "/%3Flat%3D" + this.feature.geometry.coordinates[1]
                  + "%26lng%3D" + this.feature.geometry.coordinates[0]
                  + "%26zoom%3D" + "15"
                  + "%26layers%3D" + this.layer;
    return baseUrl + params;
  }

  /**
   * inicialitza les propietats del component
   */
  ngOnInit() {
    this.properties = this.feature.properties;
    this.road = this.properties.road;
    this.start_kp = this.properties.start_kp;
    this.end_kp = this.properties.end_kp;
    this.city = this.properties.city;
    this.meteoId = this.properties.causeId;
    this.cause = this.properties.cause[0] +
    this.properties.cause.substring(1).toLowerCase();
    this.levelOfService = this.properties.levelOfService;
    this.iconUrl = this.getUrl();
    this.source = this.properties.source;
    this.comments = this.properties.comments;
    this.direction = this.properties.direction;
  }

  /**
   * Retorna la URL de la icona del marcador depenent de a quina capa pertany
   * @returns {string} URL de la icona del marcador depenent de a quina capa pertany
   */
  getUrl(){
    var url: string;
    if(this.layer === "METEO"){
      var nomCausa = this.meteoIds.get(this.meteoId);
      url = 'assets/img/' + nomCausa;
      if(this.levelOfService === '5') url = url + 'Negro';
    }
    else url = 'assets/img/' + this.layer + '_MARKER';
    
    return url + '.svg';

  }

}


